import React from "react";
import Dashboard from "./Components/Dashboard";
import "./App.css";

function App() {
  return (
    <div className="App">
      <h1>Dashboard</h1>
      <Dashboard />
    </div>
  );
}

export default App;
